//Modules
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

//Utils
import useFetchXML from '../../utils/useFetchXML'

//Components
import PlanoEstudos from './widgets/PlanoEstudos'
import MaisInfo from './widgets/MaisInfo'

//Constants
import { details } from '../../constants/cursos'

const { REACT_APP_GUIAECTS_CURSOS, REACT_APP_GUIAECTS_CURSO_DETALHE } = process.env

function CursoDetalhe({ slugCurso, lang }) {
    const codCurso = slugCurso.split("-")

    const GUIAECTS_LANG = process.env[`REACT_APP_GUIAECTS_${lang.toUpperCase()}`]

    const { data: cursoDetalhe } = useFetchXML(`${REACT_APP_GUIAECTS_CURSO_DETALHE}${GUIAECTS_LANG}&cod_escola=${codCurso[codCurso.length-2]}&cod_curso=${codCurso[codCurso.length-1]}`)
    const { data: listaCursos } = useFetchXML(`${REACT_APP_GUIAECTS_CURSOS}${GUIAECTS_LANG}`)
    const [detalhe, setDetalhe] = useState(null)
    const [curso, setCurso] = useState(null)

    let navigate = useNavigate()

    useEffect(() => {
        cursoDetalhe && setDetalhe(cursoDetalhe.ipb.escola[0].curso[0])
        if (listaCursos) {
            let cursoFilter = listaCursos.ipb.curso.filter((curso) => {
                if (curso.$.cod_curso === codCurso[codCurso.length-1]) {
                    return curso.$
                }else{
                    return false
                }
            })
            cursoFilter.length > 0 && setCurso(cursoFilter[0].$)
        }
    },[cursoDetalhe, listaCursos, codCurso])    

    if (curso) {
        var titulo
        switch(curso.tipo){
            case "C":
                titulo = {
                            pt: "CTeSP",
                            en: "CTeSP"
                        } 
            break;
            case "T":
                titulo = {
                            pt: "CTeSP",
                            en: "CTeSP"
                        } 
            break;
            case "L":
                titulo = {
                            pt: "Licenciaturas",
                            en: "Bachelor's Degree"
                        } 
            break;
            case "PG":
                titulo = {
                            pt: "Pós-Graduação",
                            en: "Postgraduation Course"
                        } 
            break;
            case "M":
                titulo = {
                            pt: "Mestrado",
                            en: "Master's Degree"
                        } 
            break;
            case "D":
                titulo = {
                            pt: "Doutoramento",
                            en: "Doctorate"
                        } 
            break;
    
            default:
        }
    }

  return (
    <>
       { (detalhe && curso) ?
        <>
            <div className="container page title">
                <div className="row">
                    <div className="col-md-3">
                        <div className='courseTitle'>{titulo[lang]}</div>                        
                    </div>                    
                </div>
            </div>

            <section id={codCurso[codCurso.length-1]} className="course-detail">
                <article className='my-5'>
                    <div className="container page">
                        <div className="row">
                            <div className="col-md-3">                                
                                <button onClick={() => navigate(-1)}><span className="material-icons-outlined course-back">arrow_back</span></button>
                            </div>                    
                            <div className="col-md-9">
                                <div className="position-relative">
                                    <p className='course-title-detail'><strong>{curso.nome}</strong></p>
                                    {detalhe?.academic_authorities[0] !== "" &&
                                        <p><strong>{details.diretor[lang]} </strong>{detalhe.academic_authorities[0].authority[0].$.name} [<a href={`mailto:${detalhe.academic_authorities[0].authority[0].$.login}@ipb.pt`}>{`${detalhe.academic_authorities[0].authority[0].$.login}@ipb.pt`}</a>]</p>
                                    }
                                </div>                                        
                            </div>
                        </div>
                    </div>
                </article>
                <MaisInfo detalhe={detalhe} lang={lang} />
                {detalhe.planos[0].plano.map((plano, index) => (
                    <PlanoEstudos key={index} plano={plano} index={index} planoCount={detalhe.planos[0].plano.length} lang={lang} />
                ))}
            </section>
        </>
        :<>
            <div className="container page title">
                <div className="row">
                    <div className="col-md-6">
                        <h3>{details.notFound[lang]}</h3> 
                         <div className='course-detail'>
                            <button onClick={() => navigate(-1)}><span className="material-icons-outlined course-back">arrow_back</span></button>                           
                        </div>
                    </div>                    
                </div>
            </div>
        </>} 
    </> 
  )
}

export default CursoDetalhe